/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
$('.product-template .product__submedia-list').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  prevArrow: ".slick-prev",
  nextArrow: ".slick-next",
  responsive: [
    {
      breakpoint: 750,
      settings: {
        slidesToShow: 3
      }
    }
  ]
});

$('.jsThumb').on('click',function(){
  if($('.product__media-container[data-media-id="'+$(this).attr('data-id')+'"]').length) {
    $('.product__media-container[data-media-id="'+$(this).attr('data-id')+'"]').removeClass('hide').siblings('.product__media-container').addClass('hide');
  }
});
